import { TransparentButton, Typography } from '@libs/components';
import { DropdownIcon } from 'src/assets';
import styled from 'styled-components';

export const OptionWrapper = styled(TransparentButton)`
  display: flex;
  align-items: center;
  justify-content: space-between;

  position: relative;
  padding: 2.5rem 1.6rem;
  width: 100%;

  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};
  border-radius: ${({ theme }) => theme.borderRadius.x4};
`;

export const OptionIconTitleWrapper = styled.div`
  display: flex;
  align-items: Center;
  gap: 2rem;
`;

export const Img = styled.img`
  width: 3.8rem;
  height: 3.8rem;
`;

export const ArrowIcon = styled(DropdownIcon)`
transform: rotate:90deg;
`;

export const BlueDisclaimerWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  background-color: ${({ theme }) => theme.colors.interactive.brandColor};
  border-top-right-radius: ${({ theme }) => theme.borderRadius.x4};
  border-bottom-left-radius: ${({ theme }) => theme.borderRadius.x4};
  padding: 0.4rem 1.2rem;
`;

export const BlueDisclaimerText = styled(Typography)`
  color: ${({ theme }) => theme.colors.text.interactive};
`;
